import * as React from 'react';

import { QueryBuilderModel } from 'bones/utils/queryBuilder/model';

export const QueryBuilderModelContext = React.createContext<QueryBuilderModel>({
  classesByIri: {},
  propertiesByIri: {},
});

export const useQueryBuilderModelContext = () => {
  const model = React.useContext(QueryBuilderModelContext);
  return model;
};

export const useOnQueryClasses = ({
  disabled,
  query,
  propertyIri,
}: {
  disabled?: boolean;
  query: string;
  propertyIri?: string;
}) => {
  const { onQueryClasses } = useQueryBuilderModelContext();
  React.useEffect(() => {
    if (onQueryClasses && !disabled) {
      onQueryClasses(query, propertyIri);
    }
  }, [disabled, onQueryClasses, propertyIri, query]);
};

export const useOnQueryProperties = ({
  disabled,
  query,
  classIri,
}: {
  disabled?: boolean;
  query: string;
  classIri?: string;
}) => {
  const { onQueryProperties } = useQueryBuilderModelContext();
  React.useEffect(() => {
    if (onQueryProperties && !disabled) {
      onQueryProperties(query, classIri);
    }
  }, [classIri, disabled, onQueryProperties, query]);
};
